import Base from './Base';

export type ApiCollectionsResponse = ApiListResponse<Collection>;

class Collections extends Base {
    get(query = null, page = null, count = null, opts = null) {
        return this.getJSON<ApiCollectionsResponse>(
            '/collections',
            {
                ...(page !== null ? { page } : null),
                ...(count !== null ? { count } : null),
                ...query,
            },
            opts,
        );
    }

    findBySlug(slug, opts = null): Promise<Collection | null> {
        return this.getJSON<Collection>(
            '/collections',
            {
                uri: slug,
            },
            opts,
        ).catch((e) => {
            if (e.status === 404) {
                return null;
            }
            throw e;
        });
    }
}

export default Collections;
